export default {
  ['language-cn']: '中文',
  ['language-en']: 'EN',
  ['change-language']: 'Language'
}
